module.exports = {
	"classes": [
		"auth-catalog-index-page",
		"header-dark"
	],
	"title": "`${technology}` Authentication",
	"metas": {
		"description": "Easily add authentication to your `${technology}` app. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"robots": "index, follow"
	},
	"opengraph": {
		"og:title": "Log in to your `${technology}` App with any Identity Provider",
		"og:description": "Easily add authentication to your `${technology}`. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"og:sitename": "Auth0"
	},
	"twittercard": {
		"twitter:title": "Log in to your `${technology}` App with any Identity Provider",
		"twitter:description": "Easily add authentication to your `${technology}`. Includes, identity management, single sign on, multifactor authentication, social login and more."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/auth-catalog-index/universal/metadata-technology.json
// module id = 1106
// module chunks = 0